import type { ExtractPropTypes } from "vue";

export type ItemSearchCandidate = {
    alias?: string;
    type: string;
    name: string;
    id: string | number;
};
export type ItemSearchCandidates = {
    type: string;
    data: ItemSearchCandidate[];
};

export const ItemSearchPropsOption = {
    width: { type: Number, default: 212 }, //* 选项最大宽度
    number: { type: Number, default: 3 }, //* 可允许展示选项个数
    placeholder: { type: String },
} as const;

export type ItemSearchProps = ExtractPropTypes<typeof ItemSearchPropsOption>;

export const ItemSearchEmits = {
    search: (_data: ItemSearchCandidate[]) => true,
};
